import { Link, NavLink } from "react-router-dom";
import { EnvelopeSimple, MapTrifold, Star, Truck } from "@phosphor-icons/react";

const BrandLink = () => (
  <Link data-testid="nav-link-home" to="/" className="flex min-w-0 items-center gap-3">
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-[#09090B] text-white">
      <Truck data-testid="brand-truck-icon" size={24} weight="fill" />
    </span>
    <span className="min-w-0">
      <span data-testid="brand-title" className="block truncate font-display text-lg font-black leading-none tracking-normal">
        DTNA Elite Support
      </span>
      <span data-testid="brand-subtitle" className="block truncate text-xs font-bold uppercase tracking-[0.18em] text-[#0055FF]">
        Facility Network
      </span>
    </span>
  </Link>
);

const PrimaryNavigation = () => (
  <nav data-testid="primary-navigation" className="hidden items-center gap-2 md:flex">
    <NavLink
      data-testid="nav-link-directory"
      to="/"
      className="inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-bold text-[#52525B] transition-colors duration-200 hover:bg-zinc-100 hover:text-[#09090B]"
    >
      <MapTrifold size={18} weight="bold" /> Directory
    </NavLink>
    <a
      data-testid="nav-link-ratings"
      href="/#ratings"
      className="inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-bold text-[#52525B] transition-colors duration-200 hover:bg-zinc-100 hover:text-[#09090B]"
    >
      <Star size={18} weight="bold" /> Ratings
    </a>
  </nav>
);

const ListingRequestShortcut = () => (
  <a
    data-testid="btn-listing-request-shortcut"
    href="/#listing-request"
    className="inline-flex items-center gap-2 rounded-md bg-[#0055FF] px-4 py-2 text-sm font-bold text-white transition-colors duration-200 hover:bg-[#0040CC]"
  >
    <EnvelopeSimple data-testid="listing-request-shortcut-icon" size={18} weight="bold" />
    <span className="hidden sm:inline">Contact Us to Add Location</span>
    <span className="sm:hidden">Contact</span>
  </a>
);

export const AppShell = ({ children }) => {
  return (
    <div data-testid="app-shell" className="min-h-screen bg-white">
      <header
        data-testid="site-header"
        className="sticky top-0 z-[1000] border-b border-black/10 bg-white/75 backdrop-blur-xl backdrop-saturate-150"
      >
        <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
          <BrandLink />
          <PrimaryNavigation />
          <ListingRequestShortcut />
        </div>
      </header>
      <main data-testid="main-content">{children}</main>
    </div>
  );
};